// SPDX-FileCopyrightText: Copyright (C) 2026 provide.io llc
// SPDX-License-Identifier: Apache-2.0
export const MAX_RECENT = 20;
const KEY = "uwhois.recent";

function read(): string[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr: unknown = JSON.parse(raw);
    return Array.isArray(arr) ? (arr.filter((x) => typeof x === "string") as string[]) : [];
  } catch {
    return [];
  }
}

function write(values: readonly string[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(values));
  } catch {
    // quota or storage unavailable — ignore
  }
}

export function listRecent(): string[] {
  return read();
}

export function addRecent(name: string): void {
  const clean = name.trim().toLowerCase();
  if (!clean) return;
  const cur = read().filter((n) => n !== clean);
  cur.unshift(clean);
  write(cur.slice(0, MAX_RECENT));
}

export function clearRecent(): void {
  write([]);
}
